import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _jsx from "@babel/runtime/helpers/jsx";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

var _SlideIcon, _SlideIcon2, _Line;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { memo, useRef, useEffect, useState, useCallback } from 'react';
import { SectionMenuWrapper, SectionMenuStyled, Line, SectionMenuItemStyled, SlideIcon, PrevSlideBtn, NextSlideBtn } from './styles';
import { jsx as _jsx2 } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function SectionMenu(_ref) {
  var menuItems = _ref.menuItems,
      setMenu = _ref.setMenu,
      visibleScroll = _ref.visibleScroll;
  var refActive = useRef();
  var navRef = useRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHiddenNext = _useState2[0],
      setHideNext = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isHiddenPrev = _useState4[0],
      setHidePrev = _useState4[1];

  var handleSlide = useCallback(function (value) {
    var _navRef$current;

    return navRef == null ? void 0 : (_navRef$current = navRef.current) == null ? void 0 : _navRef$current.scrollBy({
      top: 0,
      left: value,
      behavior: 'smooth'
    });
  }, []);
  var hideNavigation = useCallback(function () {
    var _navRef$current2, _navRef$current3, _navRef$current4, _navRef$current5;

    if ((navRef == null ? void 0 : (_navRef$current2 = navRef.current) == null ? void 0 : _navRef$current2.scrollLeft) === 0) {
      setHidePrev(true);
    } else {
      setHidePrev(false);
    }

    if ((navRef == null ? void 0 : (_navRef$current3 = navRef.current) == null ? void 0 : _navRef$current3.offsetWidth) + (navRef == null ? void 0 : (_navRef$current4 = navRef.current) == null ? void 0 : _navRef$current4.scrollLeft) === (navRef == null ? void 0 : (_navRef$current5 = navRef.current) == null ? void 0 : _navRef$current5.scrollWidth)) {
      setHideNext(true);
    } else {
      setHideNext(false);
    }
  }, []);
  useEffect(function () {
    var _navRef$current6;

    // eslint-disable-next-line no-unused-expressions
    navRef == null ? void 0 : (_navRef$current6 = navRef.current) == null ? void 0 : _navRef$current6.addEventListener('scroll', hideNavigation);
    return function () {
      var _navRef$current7;

      return navRef == null ? void 0 : (_navRef$current7 = navRef.current) == null ? void 0 : _navRef$current7.removeEventListener('scroll', hideNavigation);
    };
  }, []);
  useEffect(function () {
    return refActive == null ? void 0 : refActive.current.scrollIntoView({
      block: 'nearest',
      behavior: 'smooth',
      inline: 'center'
    });
  }, [menuItems]);
  return /*#__PURE__*/_jsx(SectionMenuWrapper, {}, void 0, /*#__PURE__*/_jsx(PrevSlideBtn, {
    onClick: function onClick() {
      return handleSlide(-150);
    },
    isHidden: isHiddenPrev
  }, void 0, _SlideIcon || (_SlideIcon = /*#__PURE__*/_jsx(SlideIcon, {
    name: "prevSlide"
  }))), /*#__PURE__*/_jsx(NextSlideBtn, {
    onClick: function onClick() {
      return handleSlide(+150);
    },
    isHidden: isHiddenNext
  }, void 0, _SlideIcon2 || (_SlideIcon2 = /*#__PURE__*/_jsx(SlideIcon, {
    name: "nextSlide"
  }))), /*#__PURE__*/_jsxs(SectionMenuStyled, {
    ref: navRef,
    $visibleScroll: visibleScroll,
    children: [_Line || (_Line = /*#__PURE__*/_jsx(Line, {})), menuItems.map(function (menuItem) {
      return /*#__PURE__*/_jsx2(SectionMenuItemStyled, _objectSpread(_objectSpread({
        isActive: menuItem.isActive
      }, menuItem.isActive ? {
        ref: refActive
      } : {}), {}, {
        onClick: function onClick() {
          return setMenu(menuItem.name);
        },
        children: menuItem.name
      }), menuItem.name);
    })]
  }));
}

SectionMenu.defaultProps = {
  visibleScroll: false
};
export default /*#__PURE__*/memo(SectionMenu);